<template>
<div class="Resume">
    <div class="Resume_top_box">
        <div class="left_div">
            <div v-if="percentage === 100" class="text_box">您的简历完整度{{percentage}}%，快去投递感兴趣的职位吧！<p @click="goToPage()">查看职位</p></div>
            <div v-if="percentage > 0 && percentage < 100" class="text_box">您的简历完整度{{percentage}}%，完善简历投递感兴趣的职位吧！</div>
            <div v-if="percentage === 0" class="text_box">您的简历还没有完善，请先完善简历信息。</div>
            <div class="progress_box">
                <el-progress :stroke-width="12" :percentage="percentage" :color="customColor" :show-text="false"></el-progress>
                <span>完整度：{{percentage}}%</span>
            </div>
        </div>
        <div class="right_div">
            <p>附件简历：{{fileData.length}} / 3</p>
            <div class="annex_resume">
                <div class="file_item_box" v-for="(item, index) in fileData" :key="index">
                    <img class="icon_img1" :src="require('@/common/images/talentsimg/file_icon.png')" alt="">
                    <p>{{item.fileattname}}</p>
                    <img @click="delFile(item)" class="icon_img2" :src="require('@/common/images/talentsimg/file_del_icon.png')" alt="">
                </div>
            </div>
            <div class="handle_box">
                <div>
                    <p>默认投递：</p>
                    <el-select style="width: 122px;" v-model="value" placeholder="请选择">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <uploadFile2 v-if="fileData.length < 3" :uploadType="uploadType" @setFile="setFile" :fileRule="fileRule" ref="uploadFile"></uploadFile2>
            </div>
        </div>
    </div>
    <div class="Resume_content_box">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">我的简历</el-menu-item>
            <el-menu-item index="2">应聘记录</el-menu-item>
        </el-menu>
        <div v-show="activeMenu === '1'">
            <ResumeEdit @getProgress="getProgress" ref="resume_edit"></ResumeEdit>
        </div>
        <div v-show="activeMenu === '2'">
            <ApplyRecord ref="apply_record"></ApplyRecord>
        </div>
    </div>
</div>
</template>

<script>
import {uploadAttInfo, getResumeAttInfo, deleteAttInfo} from 'api/talentApi'
import ResumeEdit from '../components/ResumeEdit'
import ApplyRecord from '../components/ApplyRecord'
import {mapGetters, mapActions} from 'vuex'
import uploadFile2 from '../components/uploadFile2'
export default {
    name: 'Resume',
    data() {
        return {
            fileData: [],
            options: [
                {
                    value: 1,
                    label: '在线简历'
                }
            ],
            value: 1,
            activeIndex: '1',
            activeMenu: '1',
            percentage: 0,
            resumeinnerid: '',
            customColor: '#2E7FFF',
            fileRule: {
                btnName: '上传简历',
                cls: '',
                accept: 'application/pdf,.docx,.doc,.rtf',
                size: 2000,
                width: '',
                height: ''
            },
            uploadType: {
                catecode: '102',
                datatype: 'FILE'
            },
        }
    },
    created() {
        this.findResumeAttInfo()
    },
    mounted() {},
    methods: {
        delFile(val) {
            this.$confirm('确定删除附件简历经历？', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                var params = {
                    innerid: val.innerid,
                    resumeinnerid: this.resumeinnerid
                }
                deleteAttInfo({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        console.log(data.data)
                        this.findResumeAttInfo()
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        findResumeAttInfo() {
            this.setLoading(true)
            var params = {}
            getResumeAttInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.fileData = data.data.attinfolist
                    this.options = [
                        {
                            value: 1,
                            label: '在线简历'
                        }
                    ]
                    for (let index = 0; index < this.fileData.length; index++) {
                        this.options.push(
                            {
                                value: this.fileData[index].fileattname,
                                label: this.fileData[index].fileattname
                            }
                        )
                        
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        setFile(file) {
            delete file.type
            this.setLoading(true)
            var params = {
                resumeinnerid: this.resumeinnerid,
                fileatturl: JSON.stringify(file)
            }
            uploadAttInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    console.log(data.data)
                    this.findResumeAttInfo()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        goToPage() {
            this.$router.push({name: 'TalentIndex'})
        },
        getProgress(val, id) {
            this.percentage = val
            this.resumeinnerid = id
        },
        increase() {
            this.percentage += 10
            if (this.percentage > 100) {
                this.percentage = 100
            }
        },
        decrease() {
            this.percentage -= 10
            if (this.percentage < 0) {
                this.percentage = 0
            }
        },
        handleSelect(val) {
            this.activeMenu = val
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        user: function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.findResumeAttInfo()
                this.$refs.resume_edit.findResumeAllInfo()
                this.$refs.apply_record.findResumeedLiveInfo(1)
            }
        }
    },
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {ApplyRecord, ResumeEdit, uploadFile2}
}
</script>

<style lang="scss" type="text/scss">
.el-select-dropdown__item {
    max-width: 230px!important;
}
.Resume {
    font-family:PingFangSC-Regular,PingFang SC;
    color: #333;
    margin-bottom: 60px;
    .Resume_top_box {
        display: flex;
        justify-content: space-between;
        height: 174px;
        margin-bottom: 20px;
        &>div {
            background-color: #fff;
        }
        .left_div {
            width: 632px;
            box-sizing: border-box;
            padding: 54px 30px 0 20px;
            .text_box {
                height: 30px;
                margin-bottom: 22px;
                font-size: 18px;
                line-height:26px;
                display: flex;
                align-items: center;
                p {
                    border: 1px solid #409EFF;
                    border-radius: 20px;
                    color: #409EFF;
                    font-size: 14px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 30px;
                    width: 116px;
                    margin-left: 10px;
                    cursor: pointer;
                }
                p:hover {
                    border: 1px solid #0a80f5;
                    color: #0a80f5;
                }
            }
            .progress_box {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .el-progress {
                    width: 466px;
                }
                &>span {
                    font-size: 14px;
                    color: #666;
                }
            }
        }
        .right_div {
            width: 310px;
            box-sizing: border-box;
            padding: 10px;
            padding-top: 12px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            &>p {
                line-height: 20px;
                font-size: 14px;
                color: #333;
            }
            .annex_resume {
                flex: 1;
                margin: 16px 0;
                .file_item_box {
                    display: flex;
                    align-items: center;
                    .icon_img1 {
                        width: 12px;
                        height: 12px;
                        margin-right: 6px;
                    }
                    .icon_img2 {
                        width: 12px;
                        height: 12px;
                        margin-left: 12px;
                        cursor: pointer;
                    }
                    &>p {
                        font-size: 12px;
                        line-height: 18px;
                        color: #666;
                        max-width: 220px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                    }
                }
                .file_item_box + .file_item_box {
                    margin-top: 8px;
                }
            }
            .handle_box {
                display: flex;
                justify-content: space-between;
                align-items: center;
                &>div {
                    display: flex;
                    align-items: center;
                    &>p {
                        white-space: nowrap;
                    }
                    .el-input__inner {
                        height: 28px;
                        line-height: 28px;
                    }
                }
                .el-input__icon {
                    line-height: 28px;
                }
            }
        }
    }
    .Resume_content_box {
        background-color: #fff;
        padding: 0 30px;
        .el-menu-demo {
            padding-top: 0;
            padding-bottom: 0;
        }
        .el-menu--horizontal>.el-menu-item {
            color: #333;
            &.is-active {
                color: #409EFF;
            }
        }
        .el-menu--horizontal>.el-menu-item {
            height: 56px;
            line-height: 56px;
        }
    }
}
</style>